import React, { useState, useContext, useEffect } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import AuthContext from '../../context/AuthContext';

const WithdrawPage = () => {
    const { user, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [shopName, setShopName] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('/shops/settings');
                setShopName(res.data?.data?.shopName || '');
            } catch (e) {
                console.error('failed to load shop settings', e);
            }
        })();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (confirmation.trim() !== shopName) {
            setError('매장명이 일치하지 않습니다.');
            return;
        }
        if (!window.confirm('정말 탈퇴하시겠습니까? 30일 내 재로그인하지 않으면 매장 데이터가 영구 삭제됩니다.')) {
            return;
        }

        setIsSubmitting(true);
        try {
            await api.delete('/auth/withdraw', { data: { confirmation } });
            alert('탈퇴가 완료되었습니다.');
            await logout();
            navigate('/login', { replace: true });
        } catch (err) {
            const msg = err.response?.data?.errors?.[0]?.msg || '탈퇴 처리 중 오류가 발생했습니다.';
            setError(msg);
            setIsSubmitting(false);
        }
    };

    if (user?.role !== 'admin') {
        return (
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
                <Alert variant="warning">매장 대표만 회원 탈퇴를 진행할 수 있습니다.</Alert>
            </Container>
        );
    }

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <div style={{ width: '100%', maxWidth: '560px' }}>
                <Card>
                    <Card.Body className="p-4">
                        <h3 className="mb-3">회원 탈퇴</h3>

                        <Alert variant="danger">
                            <strong>탈퇴 시 진행되는 처리</strong>
                            <ul className="mb-0 mt-2" style={{ paddingLeft: '1.2rem' }}>
                                <li>매장이 즉시 휴면 상태로 전환됩니다.</li>
                                <li>정기결제(토스 빌링키)가 즉시 폐기되며 이후 결제되지 않습니다.</li>
                                <li>네이버 로그인의 경우 네이버 연동도 자동 해제됩니다.</li>
                                <li>휴면 후 <strong>30일 이내</strong> 동일 계정으로 재로그인하면 자동 복구됩니다.</li>
                                <li><strong>30일이 지나면 고객/차량/작업 이력 등 모든 매장 데이터가 영구 삭제됩니다.</strong></li>
                                <li>결제 이력은 전자상거래법에 따라 5년간 익명화 보관됩니다.</li>
                            </ul>
                        </Alert>

                        <Form onSubmit={handleSubmit}>
                            {error && <Alert variant="danger">{error}</Alert>}

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    확인을 위해 매장명 <strong>"{shopName}"</strong> 을(를) 정확히 입력해주세요.
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={confirmation}
                                    onChange={(e) => setConfirmation(e.target.value)}
                                    placeholder={shopName}
                                    required
                                    disabled={!shopName || isSubmitting}
                                />
                            </Form.Group>

                            <div className="d-flex gap-2">
                                <Button
                                    variant="outline-secondary"
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    disabled={isSubmitting}
                                    className="flex-fill"
                                >
                                    취소
                                </Button>
                                <Button
                                    variant="danger"
                                    type="submit"
                                    disabled={isSubmitting || confirmation.trim() !== shopName}
                                    className="flex-fill"
                                >
                                    {isSubmitting ? '처리 중...' : '탈퇴하기'}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
};

export default WithdrawPage;
